export function isPWAInstalled() {
    const ua = navigator.userAgent || '';
    
    const isStandaloneIOS =
        typeof window.navigator.standalone === 'boolean' &&
        window.navigator.standalone;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
    const isMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
    const isOverlay = window.matchMedia('(display-mode: window-controls-overlay)').matches;
    
    // Android Trusted Web Activity
    const isTWA =
        typeof document.referrer === 'string' &&
        document.referrer.startsWith('android-app://');
    
    const isSamsungBrowser = /SamsungBrowser/i.test(ua);
    let isStandaloneSamsung = false;
    
    if (isSamsungBrowser) {
        const screenHeight = window.screen.height || 0;
        const innerHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        const heightDifference = Math.abs(screenHeight - innerHeight);
        isStandaloneSamsung = heightDifference < 50;
    }
    
    // Chrome on Mac specific handling
    const isChromeOnMac = /Chrome/.test(ua) && /Macintosh/.test(ua);
    
    if (isChromeOnMac && isFullscreen) {
        const screenUsage = window.innerHeight / window.screen.height;
        const isActualPWA = screenUsage >= 0.98;
        
        return (
            isStandaloneIOS ||
            isStandalone ||
            isActualPWA ||
            isMinimalUI ||
            isOverlay ||
            isTWA ||
            isStandaloneSamsung
        );
    }
    
    return (
        isStandaloneIOS ||
        isStandalone ||
        isFullscreen ||
        isMinimalUI ||
        isOverlay ||
        isTWA ||
        isStandaloneSamsung
    );
}